import { present } from '@cian/newbuilding-utils';
import { IRegion } from '../../types/regions';

export function isCity(region: IRegion) {
  return present(region.parentId) || region.id === 1;
}
